import * as React from 'react';
import Router from './Router';
import { createStyles, makeStyles } from '@material-ui/styles';

const usePageStyles = makeStyles(() =>
	createStyles({
		root: {
			backgroundColor: 'rgba(63, 81, 181, 0.04)',
			height: '100vh',
			width: '100%',
			flexGrow: 1,
			display: 'flex',
			alignItems: 'center',
		}
	}),
);

const App = () => {
	const classes = usePageStyles();
	return (
		<div className={classes.root}>
			<Router />
		</div>
	);
};

export default App;
